<div class="notification-location-data-stale-toast" (click)="refreshNotificationLocationData()">
    <div class="message">{{localize(langSection.Toast, langText.UserDataIsStale)}}</div>
    <button type="button" class="close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>